import { HomeFilled, HomeOutlined, UnorderedListOutlined, UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_MODULE_KEYS } from "modules/appModuleKeys";
import { canAccessModule } from "modules/appModuleAccess";
import useAuthStore from "stores/useAuthStore";
import "./MobileFooter.css";

export default function MobileFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("common");
  const userData = useAuthStore((s) => s.userData);
  const userRole = userData?.role;

  const searchParams = new URLSearchParams(location.search);
  const view = searchParams.get("view");
  const isDashboard = location.pathname === "/dashboard";
  const isObligations = location.pathname === "/obligations";
  const isMyObligations = isObligations && view === "my";
  const isTeamObligations = isObligations && view !== "my";
  // Footer tabs respect module registry + userData.modules (not legacy role-only checks).
  const canViewDashboard = canAccessModule(APP_MODULE_KEYS.DASHBOARD, userData);
  const canViewObligations = canAccessModule(APP_MODULE_KEYS.OBLIGATIONS, userData);
  const canViewTeamObligations = canViewObligations && (userRole === "admin" || userRole === "owner");

  if (!canViewDashboard && !canViewObligations) return null;

  return (
    <footer className="mobile-app-footer">
      {canViewDashboard && (
        <button
          type="button"
          className={`mobile-app-footer-item ${isDashboard ? "is-active" : ""}`}
          onClick={() => navigate("/dashboard")}
        >
          {isDashboard ? <HomeFilled /> : <HomeOutlined />}
          <span>{t("mobileDashboard:footer_descriptors.home")}</span>
        </button>
      )}

      {canViewObligations && (
        <button
          type="button"
          className={`mobile-app-footer-item ${isMyObligations ? "is-active" : ""}`}
          onClick={() => navigate("/obligations?view=my")}
        >
          <UserOutlined />
          <span>{t("mobileDashboard:footer_descriptors.my_obligations")}</span>
        </button>
      )}

      {canViewTeamObligations && (
        <button
          type="button"
          className={`mobile-app-footer-item ${isTeamObligations ? "is-active" : ""}`}
          onClick={() => navigate("/obligations")}
        >
          <UnorderedListOutlined />
          <span>{t("mobileDashboard:footer_descriptors.obligations")}</span>
        </button>
      )}
    </footer>
  );
}
